module.exports = __webpack_public_path__ + "img/spider.20fb62ba.svg";